const perm: number[] = [151,160,137,91,90,15,131,13,201,95,96,53,194,233,7,225,140,36,103,30,69,142,8,99,37,240,21,10,23,190,6,148,247,120,234,75,0,26,197,62,94,252,219,203,117,35,11,32,57,177,33,88,237,149,56,87,174,20,125,136,171,168,68,175,74,165,71,134,139,48,27,166,77,146,158,231,83,111,229,122,60,211,133,230,220,105,92,41,55,46,245,40,244,102,143,54,65,25,63,161,1,216,80,73,209,76,132,187,208,89,18,169,200,196,135,130,116,188,159,86,164,100,109,198,173,186,3,64,52,217,226,250,124,123,5,202,38,147,118,126,255,82,85,212,207,206,59,227,47,16,58,17,182,189,28,42,223,183,170,213,119,248,152,2,44,154,163,70,221,153,101,155,167,43,172,9,129,22,39,253,19,98,108,110,79,113,224,232,178,185,112,104,218,246,97,228,251,34,242,193,238,210,144,12,191,179,162,241,81,51,145,235,249,14,239,107,49,192,214,31,181,199,106,157,184,84,204,176,115,121,50,45,127,4,150,254,138,236,205,93,222,114,67,29,24,72,243,141,128,195,78,66,215,61,156,180];
const p = new Array(512);
for (let i = 0; i < 512; i++) { // tslint:disable-line:prefer-for-of
    p[i] = perm[i & 255]; // tslint:disable-line:no-bitwise
}

function fade(t: number): number { return t * t * t * (t * (t * 6 - 15) + 10); }
function lerp(a: number, b: number, t: number): number { return a + (b - a) * t; }
function grad(hash: number, x: number): number { // tslint:disable-line:no-bitwise
    const h = hash & 15; // tslint:disable-line:no-bitwise
    let g = 1 + (h & 7); // tslint:disable-line:no-bitwise
    if ((h & 8) !== 0) { // tslint:disable-line:no-bitwise
        g = -g;
    }
    return g * x;
}
function noise1d(x: number): number {
    const X = Math.floor(x) & 255; // tslint:disable-line:no-bitwise
    x -= Math.floor(x);
    const u = fade(x);
    const a = p[X];
    const b = p[X + 1];
    return lerp(grad(a, x), grad(b, x - 1), u);
}
// Individual parameter enable states
let enabledStates = {
    noiseScaleR: false, // Disabled random walk for RGB noise parameters
    noiseScaleG: false,
    noiseScaleB: false,
    noiseOpacity: false,
    forceAmplitude: true,
    forceScale: true,
    forceSpeed: true,
    forceRadial: true
};

// Static fallback values when random walk is disabled
const staticValues = {
    noiseScale: [2.5, 2.5, 2.5],
    noiseOpacity: 0.0,
    forceParams: [0.02, 2, 0.5, 0]
};

// Current values
const scale: [number, number, number] = [1, 1, 1];
let opacity: number = 0.0;
const forceParams: [number, number, number, number] = [0.02, 2, 0.5, 0]; // amplitude, scale, speed, radial
const speed = 0.05; // noise speed
let isEnabled = false;

// Configurable ranges for random walk
// RGB noise ranges - commented out since random walk is disabled for these parameters
// let noiseScaleRRange: [number, number] = [0, 8];
// let noiseScaleGRange: [number, number] = [0, 8];
// let noiseScaleBRange: [number, number] = [0, 8];
// let noiseOpacityRange: [number, number] = [0, 1];
let forceAmplitudeRange: [number, number] = [0, 0.6];
let forceScaleRange: [number, number] = [0.1, 20];
let forceSpeedRange: [number, number] = [0, 5];
let forceRadialRange: [number, number] = [-1, 1];

// Previous values for damping
let prevScale: [number, number, number] = [1, 1, 1];
let prevOpacity: number = 0.0;
let prevForceParams: [number, number, number, number] = [0.02, 2, 0.5, 0];

// Damping factor (0 = no damping, 1 = maximum damping)
const dampingFactor = 0.85;

export function setEnabled(enabled: boolean): void {
    isEnabled = enabled;
}

export function getEnabled(): boolean {
    return isEnabled;
}

export function update(time: number): void {
    if (!isEnabled) return;
    
    // Generate new target values using individual noise offsets for each parameter
    // RGB noise parameters - commented out random walk, using static values
    const targetScale: [number, number, number] = [
        // enabledStates.noiseScaleR ? mapToRange(noise1d(time * speed + 0), noiseScaleRRange[0], noiseScaleRRange[1]) : staticValues.noiseScale[0],
        // enabledStates.noiseScaleG ? mapToRange(noise1d(time * speed + 50), noiseScaleGRange[0], noiseScaleGRange[1]) : staticValues.noiseScale[1],
        // enabledStates.noiseScaleB ? mapToRange(noise1d(time * speed + 100), noiseScaleBRange[0], noiseScaleBRange[1]) : staticValues.noiseScale[2]
        staticValues.noiseScale[0],
        staticValues.noiseScale[1],
        staticValues.noiseScale[2]
    ];
    // const targetOpacity = enabledStates.noiseOpacity ? mapToRange(noise1d(time * speed + 150), noiseOpacityRange[0], noiseOpacityRange[1]) : staticValues.noiseOpacity;
    const targetOpacity = staticValues.noiseOpacity;
    
    // Generate force field targets with proper normalization to parameter ranges
    const targetForceParams: [number, number, number, number] = [
        enabledStates.forceAmplitude ? mapToRange(noise1d(time * speed + 200), forceAmplitudeRange[0], forceAmplitudeRange[1]) : staticValues.forceParams[0],
        enabledStates.forceScale ? mapToRange(noise1d(time * speed + 250), forceScaleRange[0], forceScaleRange[1]) : staticValues.forceParams[1],
        enabledStates.forceSpeed ? mapToRange(noise1d(time * speed + 300), forceSpeedRange[0], forceSpeedRange[1]) : staticValues.forceParams[2],
        enabledStates.forceRadial ? mapToRange(noise1d(time * speed + 350), forceRadialRange[0], forceRadialRange[1]) : staticValues.forceParams[3]
    ];
    
    // Apply damping to smooth the transitions
    scale[0] = lerp(prevScale[0], targetScale[0], 1 - dampingFactor);
    scale[1] = lerp(prevScale[1], targetScale[1], 1 - dampingFactor);
    scale[2] = lerp(prevScale[2], targetScale[2], 1 - dampingFactor);
    opacity = lerp(prevOpacity, targetOpacity, 1 - dampingFactor);
    
    forceParams[0] = lerp(prevForceParams[0], targetForceParams[0], 1 - dampingFactor);
    forceParams[1] = lerp(prevForceParams[1], targetForceParams[1], 1 - dampingFactor);
    forceParams[2] = lerp(prevForceParams[2], targetForceParams[2], 1 - dampingFactor);
    forceParams[3] = lerp(prevForceParams[3], targetForceParams[3], 1 - dampingFactor);
    
    // Apply hard boundary clamping to ensure values stay within configured ranges
    forceParams[0] = clamp(forceParams[0], forceAmplitudeRange[0], forceAmplitudeRange[1]);
    forceParams[1] = clamp(forceParams[1], forceScaleRange[0], forceScaleRange[1]);
    forceParams[2] = clamp(forceParams[2], forceSpeedRange[0], forceSpeedRange[1]);
    forceParams[3] = clamp(forceParams[3], forceRadialRange[0], forceRadialRange[1]);
    
    // Store current values as previous for next frame
    prevScale[0] = scale[0];
    prevScale[1] = scale[1]; 
    prevScale[2] = scale[2];
    prevOpacity = opacity;
    prevForceParams[0] = forceParams[0];
    prevForceParams[1] = forceParams[1];
    prevForceParams[2] = forceParams[2];
    prevForceParams[3] = forceParams[3];
}

function mapToRange(value: number, min: number, max: number): number {
    return ((value + 1) / 2) * (max - min) + min;
}

function clamp(value: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, value));
}
export function getScale(): [number, number, number] { return [scale[0], scale[1], scale[2]]; }
export function getOpacity(): number { return opacity; }
export function getForceParams(): [number, number, number, number] { return [forceParams[0], forceParams[1], forceParams[2], forceParams[3]]; }

export function setForceRanges(amplitudeRange: [number, number], scaleRange: [number, number], speedRange: [number, number], radialRange: [number, number]): void {
    forceAmplitudeRange = amplitudeRange;
    forceScaleRange = scaleRange;
    forceSpeedRange = speedRange;
    forceRadialRange = radialRange;
}

// Functions to control individual parameter enable states
export function setParameterWalkEnabled(parameterName: string, enabled: boolean): void {
    if (parameterName in enabledStates) {
        (enabledStates as any)[parameterName] = enabled;
    }
}

export function getParameterWalkEnabled(parameterName: string): boolean {
    if (parameterName in enabledStates) {
        return (enabledStates as any)[parameterName];
    }
    return true; // Default to enabled if parameter not found
}

// Functions to get current parameter values for live display
export function getCurrentValues() {
    return {
        noiseScaleR: scale[0],
        noiseScaleG: scale[1], 
        noiseScaleB: scale[2],
        noiseOpacity: opacity,
        forceAmplitude: forceParams[0],
        forceScale: forceParams[1],
        forceSpeed: forceParams[2],
        forceRadial: forceParams[3]
    };
}

// Function to set static values when walk is disabled
export function setStaticValue(parameterName: string, value: number): void {
    switch (parameterName) {
        case 'noiseScaleR':
            staticValues.noiseScale[0] = value;
            if (!enabledStates.noiseScaleR) scale[0] = value;
            break;
        case 'noiseScaleG':
            staticValues.noiseScale[1] = value;
            if (!enabledStates.noiseScaleG) scale[1] = value;
            break;
        case 'noiseScaleB':
            staticValues.noiseScale[2] = value;
            if (!enabledStates.noiseScaleB) scale[2] = value;
            break;
        case 'noiseOpacity':
            staticValues.noiseOpacity = value;
            if (!enabledStates.noiseOpacity) opacity = value;
            break;
        case 'forceAmplitude':
            staticValues.forceParams[0] = value;
            if (!enabledStates.forceAmplitude) forceParams[0] = value;
            break;
        case 'forceScale':
            staticValues.forceParams[1] = value;
            if (!enabledStates.forceScale) forceParams[1] = value;
            break;
        case 'forceSpeed':
            staticValues.forceParams[2] = value;
            if (!enabledStates.forceSpeed) forceParams[2] = value;
            break;
        case 'forceRadial':
            staticValues.forceParams[3] = value;
            if (!enabledStates.forceRadial) forceParams[3] = value;
            break;
    }
}

// Function to update the parameter ranges from UI controls
export function setRanges(
    // RGB noise ranges - commented out since random walk is disabled for these parameters
    // noiseScaleRRange_: [number, number],
    // noiseScaleGRange_: [number, number], 
    // noiseScaleBRange_: [number, number],
    // noiseOpacityRange_: [number, number],
    _noiseScaleRRange: [number, number],
    _noiseScaleGRange: [number, number], 
    _noiseScaleBRange: [number, number],
    _noiseOpacityRange: [number, number],
    forceAmplitudeRange_: [number, number],
    forceScaleRange_: [number, number],
    forceSpeedRange_: [number, number],
    forceRadialRange_: [number, number]
): void {
    // RGB noise ranges - commented out since random walk is disabled for these parameters
    // noiseScaleRRange = noiseScaleRRange_;
    // noiseScaleGRange = noiseScaleGRange_;
    // noiseScaleBRange = noiseScaleBRange_;
    // noiseOpacityRange = noiseOpacityRange_;
    forceAmplitudeRange = forceAmplitudeRange_;
    forceScaleRange = forceScaleRange_;
    forceSpeedRange = forceSpeedRange_;
    forceRadialRange = forceRadialRange_;
}
